export default __webpack_public_path__ + "static/new-buttons-88f42087a9affcfdab6473784344fdf3.png";